module.exports = __webpack_public_path__ + "img/step2-n.6b23266e.png";